import { Component, input } from '@angular/core';
import { Template } from '../../../user/templates/template';
import { UiCoreModule } from '@softline/ui-core';

@Component({
    selector: 'soft-template-option',
    imports: [UiCoreModule],
    templateUrl: './template-option.component.html',
    styleUrl: './template-option.component.css'
})
export class TemplateOptionComponent<T> {
  value = input.required<Template<T>>();
}
